import { getLocaleStore } from '@/i18n/index';
import CN_DEFAULT_FONT_FAMILY_NAME_TTF from './assets/AlibabaPuHuiTi-Regular.ttf';
import CN_DEFAULT_FONT_FAMILY_NAME_WOFF2 from './assets/AlibabaPuHuiTi-Regular.woff2';
import EN_DEFAULT_FONT_FAMILY_NAME_TTF from './assets/Poppins-Regular.ttf';
import EN_DEFAULT_FONT_FAMILY_NAME_WOFF2 from './assets/Poppins-Regular.woff2';

export const EN_DEFAULT_FONT_FAMILY_NAME = 'Poppins-Regular';
export const CN_DEFAULT_FONT_FAMILY_NAME = 'AlibabaPuHuiTi-Regular';
let defaultFontFamily: { name: string; ttf_url: string; woff2_file_url: string } | null = null;

export const setDefaultFontFamily = (name: string) => {
    defaultFontFamily = {
        name,
        ttf_url: `${name}_TTF`,
        woff2_file_url: `${name}_WOFF2`,
    };
};
/** 获取默认字体 */
export const DEFAULT_FONT_FAMILY = () => {
    if (defaultFontFamily) {
        return defaultFontFamily;
    }
    const locale = getLocaleStore().locale;
    switch (locale) {
        case 'en': {
            /** Poppins-Regular  */
            return {
                name: EN_DEFAULT_FONT_FAMILY_NAME,
                ttf_url: EN_DEFAULT_FONT_FAMILY_NAME_TTF,
                woff2_file_url: EN_DEFAULT_FONT_FAMILY_NAME_WOFF2,
            };
        }
        case 'zh-Hans':
        default: {
            return {
                name: CN_DEFAULT_FONT_FAMILY_NAME,
                ttf_url: CN_DEFAULT_FONT_FAMILY_NAME_TTF,
                woff2_file_url: CN_DEFAULT_FONT_FAMILY_NAME_WOFF2,
            };
        }
    }
};
